import axios from "axios";
import apiMixins from "@/mixins/apiMixins";

export default {
	mixins: [apiMixins],
	methods: {
		/* checa se a url é uma url do vimeo valida */
		checkUrlIsVideoOfVimeo: function(url) {
			return url.match(/vimeo/g) !== null ? true : false;
		},
		/* retorna o conteudo do frame para adicionar */
		getContentOfEmbedVimeo: async function(event, siteId, postId) {
			const linkParts = event.split("/");
	        const videoId = linkParts[linkParts.length - 1];

	        const uri = {
	          uri: `https://vimeo.com/${videoId}`,
	        };
	        
	        const url = `/site/${siteId}/post/${postId}/video/link`;

	        return await this.requestApiData(url, "post", uri);
		}
	}

}


// WEBPACK FOOTER //
// ./src/mixins/vimeoMixins.js